import Hero from "../components/Hero"; 
import Vision from "../pages/Vision";

export default function Home() {
  return (
    <>
      <Hero />
      <Vision />
    </>
  );
}
